import { useEffect, useLayoutEffect } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import type { RouteObject } from "react-router-dom";
import { isAuthenticated } from "@/lib/auth";
import AdminLayout from "../components/feature/AdminLayout";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import About from "../pages/about/page";
import Product from "../pages/product/page";
import NewsroomPage from "../pages/newsroom/page";
import NewsroomDetailPage from "../pages/newsroom/detail/page";
import AdminLoginPage from "../pages/admin/login/page";
import AdminProducts from "../pages/admin/products/page";
import AdminMainSlider from "../pages/admin/main-slider/page";
import AdminNewsroom from "../pages/admin/newsroom/page";
import AdminPublications from "../pages/admin/publications/page";
import AdminBioArt from "../pages/admin/bio-art/page";
import MainSliderDetailPage from "../pages/main-slider/detail/page";
import PublicationsPage from "../pages/publications/page";
import BioArtPage from "../pages/bio-art/page";

function ProtectedRoute({ children }: { children: React.ReactNode }) {
  const navigate = useNavigate();

  useEffect(() => {
    if (!isAuthenticated()) {
      navigate("/admin/login", { replace: true });
    }
  }, [navigate]);

  if (!isAuthenticated()) return null;
  return <>{children}</>;
}

/** 로그인된 상태에서 /admin/login 접근 시 관리자 Main Slider로 이동 */
function AdminLoginGate() {
  const navigate = useNavigate();
  const loggedIn = isAuthenticated();

  useLayoutEffect(() => {
    if (loggedIn) {
      navigate("/admin/main-slider", { replace: true });
    }
  }, [loggedIn, navigate]);

  if (loggedIn) {
    return <Navigate to="/admin/main-slider" replace />;
  }

  return <AdminLoginPage />;
}

const routes: RouteObject[] = [
  { path: "/", element: <Home /> },
  { path: "/about", element: <About /> },
  { path: "/product", element: <Product /> },
  { path: "/bio-art", element: <BioArtPage /> },
  { path: "/newsroom", element: <NewsroomPage /> },
  { path: "/newsroom/:type/:id", element: <NewsroomDetailPage /> },
  { path: "/publications", element: <PublicationsPage /> },
  { path: "/main-slider/:id", element: <MainSliderDetailPage /> },
  {
    path: "/admin",
    children: [
      { path: "login", element: <AdminLoginGate /> },
      {
        element: (
          <ProtectedRoute>
            <AdminLayout />
          </ProtectedRoute>
        ),
        children: [
          { index: true, element: <Navigate to="main-slider" replace /> },
          { path: "main-slider", element: <AdminMainSlider /> },
          { path: "pipeline", element: <Navigate to="/admin/main-slider" replace /> },
          { path: "products", element: <AdminProducts /> },
          { path: "bio-art", element: <AdminBioArt /> },
          { path: "newsroom", element: <AdminNewsroom /> },
          { path: "publications", element: <AdminPublications /> },
        ],
      },
    ],
  },
  { path: "*", element: <NotFound /> },
];

export default routes;
